import { yupTransformEmptyToUndefined } from "shared/utils/YupUtils";
import * as yup from "yup";

export const CapitalEventCreateWaterfallSchema = yup
  .object()
  .shape({
    pref_return_amount: yup
      .number()
      .transform(yupTransformEmptyToUndefined)
      .min(0)
      .nullable(),
    allocation_calculation_id: yup.string().notRequired(),
  })
  .required();
